import { i18n } from 'i18next';
import { CustomTypeOptions } from 'react-i18next';

export function registerForgotPasswordFormResourceBundleDe(
  i18next: i18n
): void {
  i18next.addResourceBundle(
    'de',
    'record-it-components',
    {
      form: {
        ForgotPasswordForm: {
          cancel: 'Abbrechen',
          emailLabel: 'E-Mail-Adresse',
          infoText:
            'Geben Sie ihre E-Mail-Adresse ein. Wenn Sie dann auf "$t(form.ForgotPasswordForm.sendEmail)" drücken, bekommen Sie eine E-Mail, in der Sie über einen Link ihr Passwort zurücksetzen können.',
          noEmailAddressEnteredText: 'Es wurde keine E-Mail-Addresse eingeben.',
          sendEmail: 'E-Mail senden',
          sendingEmailFailedText:
            'Es ist ein Fehler beim Senden der E-Mail aufgetreten.',
          successNotification: {
            title: 'E-Mail erfolgreich gesendet',
            message: 'Öffnen Sie die E-Mail und folgen Sie den Anweisungen.'
          },
          title: 'Passwort vergessen'
        }
      }
    } as Partial<CustomTypeOptions['resources']['record-it-components']>,
    true
  );
}
